import { createContext } from "react";

export const TankPhysicalContext = createContext({
  tankPhysical: {},
  onChange: () => {},
});
